import React from "react";
import "./Product.css";
import Brands from "./Brands";
import bars1 from "../images/bars1.jpeg";
import bars2 from "../images/bars2.jpeg";
import bars3 from "../images/bars3.jpeg";
import rode1 from "../images/rode1.png";
import rode2 from "../images/rode2.png";
import rode3 from "../images/rode3.png";

const Product = () => {
  return (
    <div className="Products__div">
      <div className="product_1">
        <div className="heading__product">
          <h1>TMT Bars</h1>
        </div>
        <div className="images__product">
          <img src={bars1} alt="bars1" />
          <img src={bars2} alt="bars2" />
          <img src={bars3} alt="bars3" />
        </div>
      </div>
      <div className="product_2">
        <div className="heading__product">
          <h1>Stainless Steel Wire Rode</h1>
        </div>
        <div className="images__product">
          {" "}
          <img src={rode1} alt="rode1" />
          <img src={rode2} alt="rode2" />
          <img src={rode3} alt="rode3" />
        </div>
      </div>
      <div>
        <Brands />
      </div>
    </div>
  );
};

export default Product;
